jQuery(function($){
    // woocommerce triggers this when a user selects a variation
  $('.variations_form').on('found_variation', function(event, variation){
    // get selected variation id
    var variationId = variation.variation_id;

    // collect all centre-codes
    var centreCodes = $('.stock-levels__item').map(function(){
      return $(this).data('centre');
    }).get();

      // If there are no centre codes, stop here
    if (!centreCodes.length) return;

    // Send an AJAX request to get stock levels for this variation at each centre
    $.post(LD.ajax_url, {
      action:        'get_variation_stock',     // WordPress AJAX action
      security:      LD.stock_nonce,            // Nonce for security
      variation_id:  variationId,               // ID of the selected variation
      centre_codes:  centreCodes                // Array of centre codes
    }, function(response){
      // If the request failed or has no data, stop
      if (!response.success) return;
      var stocks = response.data.stocks;

      // Loop through each stock item in the DOM
      $('.stock-levels__item').each(function(){
        var $li    = $(this),
            code    = $li.data('centre'),                       // Centre code from data attribute
            stock   = stocks[code] || 0,                        // Stock count for this centre (0 if missing)
            $stockP = $li.find('.stock-levels__content--stock'),// Container showing the stock info
            $count  = $stockP.find('.stock-levels__stock-count'), // Span/element with the number
            $text   = $stockP.find('.stock-levels__stock-text');  // Span/element with the "in stock"/"out of stock" text

        // update the numbers/text
        $count.text(stock > 0 ? stock : '' );
        $text.text(stock > 0 ? `${stock} in stock` : 'Out of stock');



        // remove any existing modifier, then add the right one
        $stockP
          .removeClass('stock-levels__content--stock-in stock-levels__content--stock-out')
          .addClass(
            stock > 0
              ? 'stock-levels__content--stock-in'
              : 'stock-levels__content--stock-out'
          );
      });
    });
  });
});